import { gql } from "@apollo/client";export default gql`mutation DeleteWorksheetTagMap($ids: [Int!]) {
    delete_worksheet_worksheet_tag_map(where: { id: { _in: $ids } }) {
        affected_rows
    }
}
`;
